import ComponentRegistry from "Fratello/Common/ComponentRegistry";

// Wishlist
import WishlistWidget from "Fratello/Wishlist/Widgets/WishlistWidget";

import WishlistStore from "Fratello/Wishlist/Stores/WishlistStore";

import WishlistViewsWishlistView from "Fratello/Wishlist/Views/WishlistView";
import WishlistViewsItemView from "Fratello/Wishlist/Views/ItemView";

ComponentRegistry.registerStore({WishlistStore});

ComponentRegistry.register({WishlistWidget});
ComponentRegistry.register({WishlistViewsWishlistView});
ComponentRegistry.register({WishlistViewsItemView});




// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Components/Wishlist.jsx